import { IComment } from './icomment';


export interface ICommentState {
    comment: IComment,
    comments: Array<IComment>,
    error?: any
}
